const mixin = {
    data() {
        return {
            recordsPage: [12, 24, 36, 48, 60, 120],
            pagination: {
                page: 1,
                pageCount: 0,
                maxResultCount: 12,
            },
        }
    }
}

export default mixin;